module.exports = require('airbnb-js-shims')
